module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "color": _vm.notificationColor
    },
    model: {
      value: (_vm.notification),
      callback: function($$v) {
        _vm.notification = $$v
      },
      expression: "notification"
    }
  }, [_vm._v(_vm._s(_vm.notificationText) + " "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.notification = false
      }
    }
  }, [_vm._v("Close")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a23e16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/notification.vue
// module id = 359
// module chunks = 4